/* eslint-disable */
import { loadModules } from 'esri-loader'
import axios from 'axios'
import _ from 'lodash'

const fetchData = (config, onStatisticField, tblName, remappingNode) => {
  return layersInfo(config).then(data => {
    const statisticdefinition = {
      onStatisticField: onStatisticField,
      outStatisticFieldName: 'COUNTER',
      statisticType: 'count'
    }
    const groupByFieldsArray = [onStatisticField]
    const tblRegioni = { type: 'map-layer', mapLayerId: layerIdByName(data, tblName) }
    return queryLayer(tblRegioni.mapLayerId, '1=1', false, statisticdefinition, groupByFieldsArray, [onStatisticField], config).then(results => {
      let remapResult = remapping(results, remappingNode, config)
      // console.log(remappingNode + ' :', remapResult)
      return remapResult
    })
  })
}

const regioni = (config) => {
  return fetchData(config, fieldRemap('nomeSimple', config), 'TBL_Regioni', 'regioni')
}

const tipologie = (config) => {
  return fetchData(config, fieldRemap('tipologia', config), 'DATI CARTOGRAFICI', 'tipologie')
}

const interventi = (config) => {
  return fetchData(config, fieldRemap('intervento', config), 'TBL_Interventi', 'interventi')
}

const pds = (config) => {
  return fetchData(config, 'PDS', 'TBL_Interventi', 'pds')
}

const fasi = (idAzione, config) => {
  const listaFasi = {
    Pianificazione: false,
    Concertazione: false,
    Autorizzazione: false,
    Realizzazione: false,
    Concluso: false
  }
  return layersInfo(config).then(data => {
    const tblAzioni = { type: 'map-layer', mapLayerId: layerIdByName(data, 'DATI CARTOGRAFICI') }
    return queryLayer(tblAzioni.mapLayerId, `idAzione='${idAzione}'`, false, null, null, null, config).then(results => {
      results.forEach(azione => {
        listaFasi[azione[fieldRemap('faseSimple', config)]] = true
      })
      // console.log('FASI: ', results)
      return listaFasi
    })
  })
}

const fieldRemap = (value, config) => {
  if (config.prod.isProd) return config.prod.mapping.fields[value].prod
  else return config.prod.mapping.fields[value].test
}

const indicatori = (idAzione, fase, config) => {

  return layersInfo(config).then(data => {
    const tblAzioni = { type: 'map-layer', mapLayerId: layerIdByName(data, 'DATI CARTOGRAFICI') }
    const tblIndAzioni = { type: 'map-layer', mapLayerId: layerIdByName(data, 'TBL_IndicatoriAzione') }
    const tblConfIndic = { type: 'map-layer', mapLayerId: layerIdByName(data, 'XconfIndi') }

    return queryLayer(tblIndAzioni.mapLayerId, "FASE='" + fase + "' AND IDAZIONE='" + idAzione + "'", false, null, null, null, config).then(IndAzioni => {
      const newIndAzioni = []
      IndAzioni.map(item => {
        return newIndAzioni.push(_.mapKeys(item, (_value, key) => {
          if (key.toLowerCase() === 'idazione') return 'TBL_IndicatoriAzione.idAzione'
          if (key.toLowerCase() === 'idindicatore') return 'TBL_IndicatoriAzione.idIndicatore'
          if (key.toLowerCase() === 'idpds') return 'TBL_IndicatoriAzione.idPDS'
          return 'TBL_IndicatoriAzione.' + key.toLowerCase()
        })
        )
      })
      return queryLayer(tblAzioni.mapLayerId, "IDAZIONE='" + idAzione + "'", false, null, null, null, config).then(Azioni => {
        // `IDAZIONE='${idAzione}`
        // console.log('idAzione :>> ', Azioni, fase)
        const newAzioni = []
        Azioni.map(item => {
          return newAzioni.push(_.mapKeys(item, (_value, key) => {
            if (key.toLowerCase() === 'idazione') return 'Azioni.idAzione'
            if (key.toLowerCase() === 'pds') return 'Azioni.PDS'
            if (key.toLowerCase() === 'idpds') return 'Azioni.idPDS'
            return 'Azioni.' + key.toLowerCase()
          })
          )
        })
        return queryLayer(tblConfIndic.mapLayerId, '1=1', false, null, null, null, config).then(ConfIndic => {
          const newConfIndic = []
          ConfIndic.map(item => {
            return newConfIndic.push(_.mapKeys(item, (_value, key) => {
              if (key.toLowerCase() === 'idazione') return 'XconfIndi.idAzione'
              if (key.toLowerCase() === 'pds') return 'XconfIndi.PDS'
              if (key.toLowerCase() === 'idpds') return 'XconfIndi.idPDS'
              return key
              })
            )
          })

          // var merged = _.merge( _.keyBy(newIndAzioni, 'TBL_IndicatoriAzione.idAzione'), _.keyBy(newAzioni, 'Azioni.idAzione'))
          // var values = _.values(merged)
          let merged = [];

          for(let i=0; i<newIndAzioni.length; i++) {
            merged.push({
             ...newIndAzioni[i],
             ...(newAzioni.find((itmInner) => itmInner['Azioni.idAzione'] === newIndAzioni[i]['TBL_IndicatoriAzione.idAzione']))}
            )
          }

          let merged2 = [];

          for(let i=0; i<merged.length; i++) {
            merged2.push({
             ...merged[i],
             ...(newConfIndic.find((itmInner) => itmInner['ID'] === merged[i]['TBL_IndicatoriAzione.idIndicatore']))}
            )
          }

          const vIndicators = []
          merged2.forEach(indicator => {
            let cExist = false
            vIndicators.forEach(item => {
              if (item.categoria === indicator['CATEGORIA']) cExist = true
            })
            if (!cExist) vIndicators.push({ categoria: indicator['CATEGORIA'], colore: indicator['CATCOLORE'], item: [] })
            vIndicators.forEach(item => {
              if (item.categoria === indicator['CATEGORIA']) {
                item.item.push(
                  {
                    indicatore: indicator['NOMEINDICATORE'],
                    webgisLayer: indicator['WEBGISLAYER'],
                    infoLink: indicator['INFOLINK'],
                    valore: indicator['TBL_IndicatoriAzione.valore'],
                    fase: indicator['TBL_IndicatoriAzione.fase'],
                    hidden: true,
                    idweb: indicator['ID'],
                    obiettivo: indicator['OBIETTIVO'],
                    soglia: 0.5
                  })
              }
            })
      })
      return vIndicators
        })
      })
    })

    /*
    const left = {
      type: 'data-layer',
      dataSource: generateJoinDatasource('join-table', tblAzioni, tblIndAzioni, 'idAzione', 'idAzione', 'left-inner-join')
    }
    const dataSource = generateJoinDatasource('join-table', left, tblConfIndic, 'IndicatoriAzione.idIndicatore', 'ID', 'left-inner-join')
    return listFeatures(`Azioni.idAzione='${idAzione}' AND TBL_IndicatoriAzione.fase='${fase}'`, false, dataSource, true, [fieldRemap('id', config), '*'], null, config).then(features => {
      const indicators = features.filter(indicator => {
        return indicator[fieldRemap('fase', config)] === fase // indicator[ns + 'TBL_IndicatoriAzione.fase']
      })
      const vIndicators = []
      indicators.forEach(indicator => {
        let cExist = false
        vIndicators.forEach(item => {
          if (item.categoria === indicator[fieldRemap('categoria', config)]) cExist = true
        })
        if (!cExist) vIndicators.push({ categoria: indicator[fieldRemap('categoria', config)], colore: indicator['XconfIndi.CATCOLORE'], item: [] })
        vIndicators.forEach(item => {
          if (item.categoria === indicator[fieldRemap('categoria', config)]) {
            item.item.push(
              {
                indicatore: indicator[fieldRemap('nomeindicatore', config)],
                webgisLayer: indicator[fieldRemap('webgisLayer', config)],
                infoLink: indicator[fieldRemap('infoLink', config)],
                valore: indicator[fieldRemap('valore', config)],
                fase: indicator[fieldRemap('tblFase', config)],
                hidden: true,
                idweb: indicator[fieldRemap('id', config)],
                obiettivo: indicator[fieldRemap('obiettivo', config)],
                soglia: 0.5
              })
          }
        })
      })
      return vIndicators
    })
      */
  })
}

const indicatoriOld = (idAzione, fase, config) => {
  let ns = config.prod.namespace + '.'
  if (!config.prod.isProd) ns = ''
  return layersInfo(config).then(data => {
    const tblAzioni = { type: 'map-layer', mapLayerId: layerIdByName(data, 'DATI CARTOGRAFICI') }
    const tblIndAzioni = { type: 'map-layer', mapLayerId: layerIdByName(data, 'TBL_IndicatoriAzione') }
    const tblConfIndic = { type: 'map-layer', mapLayerId: layerIdByName(data, 'XconfIndi') }
    const left = {
      type: 'data-layer',
      dataSource: generateJoinDatasource('join-table', tblAzioni, tblIndAzioni, 'idAzione', 'idAzione', 'left-inner-join')
    }
    const dataSource = generateJoinDatasource('join-table', left, tblConfIndic, 'IndicatoriAzione.idIndicatore', 'ID', 'left-inner-join')
    return listFeatures(`${ns}Azioni.idAzione='${idAzione}' AND ${ns}TBL_IndicatoriAzione.fase='${fase}'`, false, dataSource, true, [ns + fieldRemap('id', config), '*'], null, config).then(features => {
      const indicators = features.filter(indicator => {
        return indicator[ns + fieldRemap('fase', config)] === fase // indicator[ns + 'TBL_IndicatoriAzione.fase']
      })
      const vIndicators = []
      indicators.forEach(indicator => {
        let cExist = false
        vIndicators.forEach(item => {
          if (item.categoria === indicator[ns + fieldRemap('categoria', config)]) cExist = true
        })
        if (!cExist) vIndicators.push({ categoria: indicator[ns + fieldRemap('categoria', config)], colore: indicator[ns + 'XconfIndi.CATCOLORE'], item: [] })
        vIndicators.forEach(item => {
          if (item.categoria === indicator[ns + fieldRemap('categoria', config)]) {
            item.item.push(
              {
                indicatore: indicator[ns + fieldRemap('nomeindicatore', config)],
                webgisLayer: indicator[ns + fieldRemap('webgisLayer', config)],
                infoLink: indicator[ns + fieldRemap('infoLink', config)],
                valore: indicator[ns + fieldRemap('valore', config)],
                fase: indicator[ns + fieldRemap('tblFase', config)],
                hidden: true,
                idweb: indicator[ns + fieldRemap('id', config)],
                obiettivo: indicator[ns + fieldRemap('obiettivo', config)],
                soglia: 0.5
              })
          }
        })
      })
      return vIndicators
    })
  })
}

const listaFasi = () => {
  return {}
}

const caratterizzazione = (idAzione, config) => {
  const vCategorie = []
  return layersInfo(config).then(data => {
    const tblCarattConf = { type: 'map-layer', mapLayerId: layerIdByName(data, 'XconfCara') }
    // Recupera tutti i layer presenti nella tabella di configurazione XconfCara
    queryLayer(tblCarattConf.mapLayerId, '1=1', false, null, null, null, config).then(layers => {
      // Per ogni layer recuperato filtra sulla tabella indicata per idAzione
      layers = remapping(layers, 'itemLayer', config)
      layers.forEach(layer => {
        const tblCar = { type: 'map-layer', mapLayerId: layerIdByName(data, layer['nomeTabella']) }
        // Recupera le features in ogni tabella e la inserisce nell'array se sono presenti risultati
        // Raggruppa i risultati per Categoria
        queryLayer(tblCar.mapLayerId, `idAzione='${idAzione}'`, true, null, null, null, config).then(features => {
          features = remapping(features, 'caratterizzazione', config)
          if (features.length > 0) {
            let cExist = false
            vCategorie.forEach(item => {
              if (item['categoria'] === layer['categoria']) {
                cExist = true
              }
            })
            if (!cExist) vCategorie.push({categoria: layer['categoria'], colore: layer['catColore'], item: []})
            vCategorie.forEach(item => {
              if (item['categoria'] === layer['categoria']) {
                item.item.push({ features: features, layer: layer, hidden: true })
              }
            })
          }
        })
      })
    })
    console.log('CARATTERIZZAZIONE: ', { caratterizzazione: vCategorie })
    return { caratterizzazione: vCategorie }
  })
}

const viste = (filter, hasLastPhase, config) => {
  return layersInfo(config).then(data => {
    const tblAzioni = { type: 'map-layer', mapLayerId: layerIdByName(data, 'DATI CARTOGRAFICI') }
    const tblInterventi = { type: 'map-layer', mapLayerId: layerIdByName(data, 'TBL_Interventi') }
    const tblRegioni = { type: 'map-layer', mapLayerId: layerIdByName(data, 'TBL_Regioni') }
    return queryLayer(tblInterventi.mapLayerId, '1=1', false, null, null, null, config).then(Interventi => {
      const newInterventi = []
      Interventi.map(item => {return newInterventi.push(_.mapKeys(item, (_value, key) => {
        if (key.toLowerCase() === 'idpds') return 'TBL_Interventi.idPDS'
        if (key.toLowerCase() === 'pds') return 'TBL_Interventi.PDS'
        if (key.toLowerCase() === 'idazione') return 'TBL_Interventi.idAzione'
        return 'TBL_Interventi.' + key.toLowerCase()
      }))})
      return queryLayer(tblAzioni.mapLayerId, '1=1', true, null, null, null, config).then(Azioni => {
        const newAzioni = []
        Azioni.map(item => {return newAzioni.push(_.mapKeys(item, (_value, key) => {
          if (key.toLowerCase() === 'idazione') return 'Azioni.idAzione'
          if (key.toLowerCase() === 'pds') return 'Azioni.PDS'
          if (key.toLowerCase() === 'idpds') return 'Azioni.idPDS'
          return 'Azioni.' + key.toLowerCase()
        }))})
        return queryLayer(tblRegioni.mapLayerId, '1=1', false, null, null, null, config).then(Regioni => {
          const newRegioni = []
          Regioni.map(item => {return newRegioni.push(_.mapKeys(item, (_value, key) => {
            if (key.toLowerCase() === 'idazione') return 'TBL_Regioni.idAzione'
            return 'TBL_Regioni.' + key.toLowerCase()
          }))})

          var merged = _.merge(_.keyBy(newAzioni, 'Azioni.idPDS'), _.keyBy(newInterventi, 'TBL_Interventi.idPDS'))
          var values = _.values(merged)

          var mergedtot = _.merge(_.keyBy(values, 'Azioni.idAzione'), _.keyBy(newRegioni, 'TBL_Regioni.idAzione'))
          var valuestot = _.values(mergedtot)

          valuestot = _.filter(valuestot, item => item['Azioni.idAzione'] !== undefined)

          const conditionArray = filter.split('AND')
          const filterarray = conditionArray.map(i => {
            let x = i.replaceAll('\'', '').split('=')
            return {key: x[0].trim(), value: x[1].trim()}
          })

          let final = valuestot
          filterarray.forEach(i => {
            // console.log('i :>> ', i);
            final = _.filter(final, item => item[i.key] === i.value)
          })
          return final
        })
      })
    })
  })
}

const viste_old = (filter, hasLastPhase, config) => {
  if (config.prod.isProd) filter = remapFilter(filter, config)
  return layersInfo(config).then(data => {
    const tblAzioni = { type: 'map-layer', mapLayerId: layerIdByName(data, 'DATI CARTOGRAFICI') }
    const tblInterventi = { type: 'map-layer', mapLayerId: layerIdByName(data, 'TBL_Interventi') }
    const tblRegioni = { type: 'map-layer', mapLayerId: layerIdByName(data, 'TBL_Regioni') }
    const left = {
      type: 'data-layer',
      dataSource: generateJoinDatasource('join-table', tblAzioni, tblInterventi, 'idPDS', 'idPDS', 'left-inner-join')
    }
    const dataSource = generateJoinDatasource('join-table', left, tblRegioni, 'Azioni.idAzione', 'idAzione', 'left-inner-join')
    return listFeatures(filter, true, dataSource, true, ['*'], null, config).then(result => {
      if (hasLastPhase) {
        let vElab = []

        result.forEach(azione => {
          let ns = config.prod.namespace + '.'
          if (!config.prod.isProd) ns = ''
          // azione = remapping(azione, 'fields', config)
          // Crea un array raggruppando le azioni sotto il loro nome
          let exist = false

          vElab.forEach(elab => {
            if (elab.azione === azione[ns + fieldRemap('azione', config)]) exist = true
          })
          if (!exist) vElab.push({ azione: azione[ns + fieldRemap('azione', config)], items: [] })
          vElab.forEach(elab => {
            if (elab.azione === azione[ns + fieldRemap('azione', config)]) {
              let fase = azione[ns + fieldRemap('fase', config)]
              let idFase = null
              config.fasi.forEach(f => {
                if (f.name.toUpperCase() === fase.toUpperCase()) idFase = f.zIndex
              })
              azione.priority = idFase
              elab.items.push(azione)
            }
          })
        })

        let results = []
        vElab.forEach(azioniGr => {
          let maxfase = Math.max.apply(Math, azioniGr.items.map(o => { return o.priority }))
          let azioneMaxFase = azioniGr.items.filter(o => { return o.priority === maxfase })
          results.push(azioneMaxFase[0])
        })

        let remapResult = remapping(results, 'viste', config)
        return remapResult
      } else {
        let remapResult = remapping(result, 'viste', config)
        return remapResult
      }
    })
  })
}

const remapFilter = (filter, config) => {
  let newFilter = filter
  let remapKey = Object.keys(config.prod.mapping.viste)

  remapKey.forEach(x => {
    newFilter = newFilter.replace(config.prod.mapping.viste[x], x)
  })

  return newFilter
}

const createObject = (customSchema, missingKeys, data) => {
  const newObj = Object.create({})
  // add available keys
  for (let key of Object.keys(customSchema)) {
    const k = customSchema[key]
    newObj[k] = data[key]
  }
  // add missing keys
  for (let k of missingKeys) {
    newObj[k] = data[k]
  }
  return _.omitBy(newObj, _.isUndefined)
}

const remapping = (results, index, config) => {
  if (config.prod.isProd) {
    if (!results.isArray) {
      return results.map(item => {
        return createObject(config.prod.mapping[index], Object.keys(item), item)
      })
    } else {
      return createObject(config.prod.mapping[index], [], results)
    }
  } else {
    return results
  }
}

const listFeatures = (filterParameter, returnGeometry, dataSource, isJoin, outFields = ['*'], orderBy = null, config) => {
  return loadModules(
    ['esri/tasks/support/Query', 'esri/layers/MapImageLayer', 'esri/config', 'esri/core/urlUtils'], { url: config.arcgis }
  ).then(([Query, MapImageLayer, esriConfig, urlUtils]) => {
    // esriConfig.request.proxyUrl = config.proxy.url
    // urlUtils.addProxyRule({ urlPrefix: config.proxy.prefix, proxyUrl: config.proxy.url })
    const configLayer = {
      url: config.MapServer.url,
      sublayers: [{
        id: 1,
        title: 'FeaturesSet'
      }]
    }

    if (isJoin) {
      configLayer.sublayers[0].source = {
        type: 'data-layer',
        dataSource: dataSource
      }
    } else {
      configLayer.sublayers[0].source = {
        type: 'map-layer',
        mapLayerId: dataSource.mapLayerId
      }
    }

    const layers = new MapImageLayer(configLayer)
    const layer = layers.findSublayerById(1)
    const featureLayer = layer.createFeatureLayer()

    let query = new Query()
    query.returnGeometry = returnGeometry
    query.outFields = outFields
    query.where = filterParameter
    if (orderBy != null) {
      query.orderByFields = orderBy
    }

    let arr = []
    return featureLayer.queryFeatures(query).then(function (results) {
      results.features.forEach(feature => {
        let tmpObj = feature.attributes
        tmpObj.layer = feature.layer
        tmpObj.geometry = feature.geometry
        arr.push(tmpObj)
      })
      // obj = results.features.map(item => item.attributes)
      return arr
    })
  })
}

const generateJoinDatasource = (type, leftTableSource, rightTableSource, leftTableKey, rightTableKey, joinType) => {
  let objJoin = {
    type: type,
    leftTableSource: leftTableSource,
    rightTableSource: rightTableSource,
    leftTableKey: leftTableKey,
    rightTableKey: rightTableKey,
    joinType: joinType
  }
  return objJoin
}

const layersInfo = async (config) => {
  try {
    // const response = await axios.get(config.proxy.url + '?' + config.MapServer.url + '?f=pjson')
    const response = await axios.get(config.MapServer.url + '?f=pjson')
    return (response.data.layers.concat(response.data.tables))
  } catch (error) {
    console.error('layersInfoError:', error)
  }
}

const queryLayer = (tblLayerId, filter, returnGeometry, statisticDefinition, groupByFieldsArray, orderBy, config) => {
  return loadModules(
    ['esri/tasks/QueryTask', 'esri/tasks/support/Query', 'esri/config', 'esri/core/urlUtils'], { url: config.arcgis }
  ).then(([QueryTask, Query, esriConfig, urlUtils]) => {
    // esriConfig.request.proxyUrl = config.proxy.url
    // urlUtils.addProxyRule({ urlPrefix: config.proxy.prefix, proxyUrl: config.proxy.url })

    // var url = `${config.MapServer.url}/${tblLayerId}/query`
    var url = `${config.MapServer.url}/${tblLayerId}`
    // console.log('url :>> ', url);
    var queryTask = new QueryTask({
      url: url
    })

    var query = new Query()
    let definition = {}
    if (statisticDefinition !== null) {
      definition = statisticDefinition
      query.outStatistics = [definition]
      query.groupByFieldsForStatistics = groupByFieldsArray
    }
    query.returnGeometry = returnGeometry
    query.outFields = ['*']
    query.where = filter
    if (orderBy !== null) query.orderByFields = orderBy

    return queryTask.execute(query).then((results) => {
      return results.features.map(item => item.attributes)
    })
  })
}

const layerIdByName = (layers, name) => {
  return layers.filter(l => l.name === name)[0].id
}

export {
  viste,
  indicatori,
  caratterizzazione,
  regioni,
  fasi,
  tipologie,
  pds,
  listaFasi,
  interventi
}

/*
const tableFeatures = (tblLayerId, filter) => {
  return axios.get(CONFIG.proxy.url + '?' + CONFIG.MapServer.url + '/' + tblLayerId + '/query?where=' + filter + '&f=pjson&outfields=*')
    .then(function (response) {
      return (response.data.features.map(item => item.attributes))
    })
    .catch(function (error) {
      console.log('tableFeaturesError:', error)
    })
}
,
            "vistetest": {
                "Azioni.OBJECTID": "MON_VIA_W.Azioni.OBJECTID",
                "Azioni.Id": "MON_VIA_W.Azioni.IDPDS",
                "Azioni.idAzione": "MON_VIA_W.Azioni.IDAZIONE",
                "Azioni.azione": "MON_VIA_W.Azioni.AZIONE",
                "Azioni.tipologia": "MON_VIA_W.Azioni.TIPOLOGIA",
                "Azioni.fase": "MON_VIA_W.Azioni.FASE",
                "Azioni.idPDS": "MON_VIA_W.Azioni.ID",
                "Azioni.Shape_Length": "SHAPE.AREA",
                "Azioni.Shape_Area": "SHAPE.LEN",
                "TBL_Interventi.OBJECTID": "MON_VIA_W.TBL_Interventi.OBJECTID",
                "TBL_Interventi.idPDS": "MON_VIA_W.TBL_Interventi.IDPDS",
                "TBL_Interventi.intervento": "MON_VIA_W.TBL_Interventi.INTERVENTO",
                "TBL_Interventi.PDS": "MON_VIA_W.TBL_Interventi.PDS",
                "TBL_Interventi.descrizione": "MON_VIA_W.TBL_Interventi.DESCRIZIONE",
                "TBL_Interventi.area": "MON_VIA_W.TBL_Interventi.AREADESC",
                "TBL_Interventi.areaDesc": "MON_VIA_W.TBL_Interventi.AREA",
                "TBL_Regioni.OBJECTID": "MON_VIA_W.TBL_Regioni.OBJECTID",
                "TBL_Regioni.idAzione": "MON_VIA_W.TBL_Regioni.IDAZIONE",
                "TBL_Regioni.nome": "MON_VIA_W.TBL_Regioni.PERC",
                "TBL_Regioni.id": "MON_VIA_W.TBL_Regioni.NOME",
                "TBL_Regioni.sup": "MON_VIA_W.TBL_Regioni.SUP",
                "TBL_Regioni.perc": "MON_VIA_W.TBL_Regioni.ID"
            }

var queryTaskx = new QueryTask({
  url: url
})
var queryx = new Query()
queryx.returnGeometry = returnGeometry
queryx.outFields = ['*']
queryx.where = filter // Return all cities with a population greater than 1 million
if (orderBy !== null) queryx.orderByFields = orderBy

// When resolved, returns features and graphics that satisfy the query.
return queryTaskx.execute(queryx).then(function (results) {
  let mapArray = results.features.map(item => item.attributes)
  let countBy = _.countBy(mapArray, statisticDefinition.onStatisticField)
  let arrCount = []
  for (const [key, value] of Object.entries(countBy)) {
    let obj = {}
    obj[statisticDefinition.onStatisticField] = key
    obj[statisticDefinition.outStatisticFieldName] = value
    arrCount.push(obj)
  }
  return arrCount
})
*/



// WEBPACK FOOTER //
// ./src/api/index.js